import * as angular from 'angular';
import controller from './dropAndTimelineGraphs.controller';
import template from './dropAndTimelineGraphs.tpl.html';

export default angular.module('aps.directive.dropAndTimelineGraphs', [controller])
  .directive('apsDropAndTimelineGraphs', dropAndTimelineGraphsDef)
  .name;

function dropAndTimelineGraphsDef() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'DropAndTimelineGraphsCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      data: '=',
      description: '=',
      graphColor: '=',
      formatTime: '=',
      timeZoneId: '=',
      reportStartDate: '=',
      reportEndDate: '='
    },
    link: function ($scope: any) {
      $scope.$watch('vm.data', function (newVal) {
        $scope.vm.setData(newVal);
      });
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/reports/dropAndTimeLineGraphs.directive.ts